import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "formatFileSize",
  standalone: true,
})
export class FormatFileSizePipe implements PipeTransform {
  transform(bytes: number | string, decimalPoints: number = 2) {
    bytes = +bytes;

    if (!bytes) {
      return "N.A.";
    }

    const units = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = bytes / Math.pow(k, i);
    let formattedSize = size.toFixed(decimalPoints);

    if (formattedSize.endsWith(".00")) {
      formattedSize = parseInt(formattedSize).toString(); // Convert to an integer
    }

    return `${formattedSize} ${units[i]}`;
  }
}
